// LiveSocket hands its whole options object to the Phoenix Socket it wraps,
// `params` included, and the Socket appends those params to the URL it opens:
// `/live/websocket?client_id=…&client_token=…&wizard_answers=…`. Nothing reads
// them there — `Phoenix.LiveView.Socket.connect/3` ignores its params, and
// `get_connect_params/1` reads the copy each LiveView join carries in its
// payload. The URL copy only costs: the client token lands in any proxy's
// access log, and the wizard answers and review trace (free text, up to tens
// of KB) push the request line past the server's 10,000-byte limit, where
// every connect and every longpoll fallback is refused with a 414 and the
// panel never connects.
//
// So the Socket is given no params of its own; the LiveSocket keeps them for
// the joins.

/**
 * A Phoenix Socket class that never puts connect params in its URL.
 * @param {typeof import('phoenix').Socket} Socket - Phoenix's Socket class.
 * @returns {typeof import('phoenix').Socket} A subclass to hand to LiveSocket.
 */
export function joinParamsOnly (Socket) {
  return class JoinParamsSocket extends Socket {
    constructor (endPoint, opts = {}) {
      super(endPoint, { ...opts, params: {} })
    }
  }
}
